import React, { useEffect, useRef } from 'react';
import './pilaresTecnologicos.scss';
import { FaBrain, FaChartLine, FaFilm, FaLightbulb } from 'react-icons/fa';

const pilaresTecnologicos = [
  {
    id: 1,
    titulo: 'Neuropsicología aplicada a la producción',
    descripcion:
      'Desarrollamos metodologías científicas que integran la neuropsicología en cada fase del proceso audiovisual. Analizamos guiones, personajes, montaje y música desde una perspectiva neuro-psicológica para maximizar el impacto emocional en el espectador.',
    icon: <FaBrain />,
  },
  {
    id: 2,
    titulo: 'Inteligencia Artificial y análisis predictivo',
    descripcion:
      'Utilizamos modelos avanzados de IA para predecir la respuesta emocional del público, analizar datos conductuales y optimizar cada elemento de la producción con base en evidencia científica y datos reales.',
    icon: <FaChartLine />,
  },
  {
    id: 3,
    titulo: 'Business Intelligence para decisiones creativas',
    descripcion:
      'Transformamos datos emocionales y conductuales en conocimiento accionable mediante plataformas BI adaptadas, dashboards personalizados e informes neuropsicológicos que guían las decisiones creativas y estratégicas.',
    icon: <FaFilm />,
  },
  {
    id: 4,
    titulo: 'Innovación basada en neurociencia',
    descripcion:
      'Cada proyecto es una oportunidad de avanzar en el conocimiento aplicado. Investigamos, desarrollamos y validamos nuevas metodologías que conectan la ciencia del comportamiento humano con la industria audiovisual.',
    icon: <FaLightbulb />,
  },
];

const PilaresTecnologicos = () => {
  const lineRefs = useRef([]);

  useEffect(() => {
    const observerOptions = {
      threshold: 0.2,
      rootMargin: '0px 0px 0px 0px',
    };

    const lineObservers = lineRefs.current.map((lineRef) => {
      if (!lineRef) return null;
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('content__title-line--visible');
            observer.unobserve(entry.target);
          }
        });
      }, observerOptions);
      observer.observe(lineRef);
      return observer;
    });

    return () => {
      lineObservers.forEach((obs) => obs?.disconnect());
    };
  }, []);

  return (
    <div className="pilares-info">
      <section className="pilares-info__section">
        <div className="pilares-info__content">
          <h1 className="pilares-info__title">NUESTROS PILARES DE I+D+i</h1>
          <div
            ref={(el) => (lineRefs.current[0] = el)}
            className="content__title-line"
          />
          <div className="pilares-info__text">
            <p className="pilares-info__text-paragraph content__text-title-backgroundWhite">
              Nuestros pilares combinan el rigor científico de la
              neuropsicología con tecnología avanzada para generar resultados
              reales y medibles en la industria audiovisual. Investigamos,
              desarrollamos e innovamos para llevar la ciencia del
              comportamiento humano al servicio del arte.
            </p>
          </div>
        </div>
        <div className="pilares-info__cards">
          {pilaresTecnologicos.map((pilar) => (
            <div key={pilar.id} className="pilar-card">
              <div className="pilar-card__logo">
                <span className="pilar-card__icon">{pilar.icon}</span>
              </div>
              <h3 className="pilar-card__title">{pilar.titulo}</h3>
              <p className="pilar-card__description">{pilar.descripcion}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default PilaresTecnologicos;
